import GitHubMark from './Images/GitHubMark.png'
import linkedinlogo from './Images/linkedinlogo.png'
import EmailLogofrom from './Images/EmailLogo.png'



const contactFormObject = {
    contactFormArray:[ 
        {
        image: linkedinlogo,
        link: "https://www.linkedin.com/in/brandon-harris-471bb932/",
        text: "LinkedIn",
    },
    {
        image: EmailLogofrom,
        link: "mailto:BrandonMGH@Yahoo.com?Subject=Portfolio Email Message",
        text: "Email",

    },
    {
        image: GitHubMark,
        link: "https://github.com/BrandonMGH",
        text: "Github",

    },
]
  
}

export default contactFormObject